import { createFileRoute } from '@tanstack/react-router';
import { FornecedoresPage, lerBuscaFornecedores } from '@/components/fornecedores';

export const Route = createFileRoute('/_app/cadastros/fornecedores')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaFornecedores(bruto),
  component: FornecedoresRota,
});

function FornecedoresRota() {
  return <FornecedoresPage busca={Route.useSearch()} />;
}
